import React, { FC } from 'react';
import { StyledEmptyPage } from './EmptyPage.styled';
import { ReactComponent as EmptyPageIcon } from 'assets/images/empty-page-icon.svg';

const EmptyPage: FC = () => {
  return (
    <StyledEmptyPage>
      <EmptyPageIcon />
      <p>
        Drag and drop content blocks <br />
        from the side bar here
      </p>
    </StyledEmptyPage>
  );
};

export default EmptyPage;
